module.exports = __webpack_public_path__ + "static/media/CC-4.1d79dd0d.PNG";